import React from "react";

// Import Bootstrap
import { Nav, Navbar, Container, Row, Col }
  from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.css";

// Import Custom CSS
import './App.css';

// Import from react-router-dom
import {
  BrowserRouter as Router, Routes,
  Route, Link
} from "react-router-dom";

// Import other React Component
import CreateMessage from
  "./Components/create-message.component";
import MessageList from
  "./Components/message-list.component";

import { PageLayout } from './Components/PageLayout';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';

import { loginRequest } from './authConfig';
import { callMsGraph } from './graph';
import { ProfileData } from './Components/ProfileData';
import Button from 'react-bootstrap/Button';

import { useState } from 'react';

// MessageContent Component
const MessageContent = () => {
  return (
    <Router>
      <div className="App">
        <header className="App-header">
          <Navbar bg="warning" variant="light">
            <Container>
              <Navbar.Brand>
                <Link to={"/message-list"}
                  className="nav-link">
                  ⚙️ Progress Expression And Contextual Engine Organisation 🤖
                </Link>
              </Navbar.Brand>
              &nbsp;&nbsp;&nbsp;
              <Nav className="justify-content-end">
                <Nav>
                  <Link to={"/create-message"}>
                    Create Message
                  </Link>
                </Nav>
                &nbsp;&nbsp;&nbsp;
                <Nav>
                  <Link to={"/message-list"}>
                    Message List
                  </Link>
                </Nav>
                &nbsp;&nbsp;&nbsp;
              </Nav>
            </Container>
          </Navbar>
        </header>

        <Container>
          <Row>
            <Col md={12}>
              <div className="wrapper">
                <Routes>
                  <Route exact path="/"
                    element={<MessageList />} />
                  <Route path="/create-message"
                    element={<CreateMessage />} />
                  <Route path="/message-list"
                    element={<MessageList />} />
                </Routes>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Router>
  );
};

/**
 * Renders information about the signed in user and a button to retrieve data about the user
 */
const ProfileContent = () => {
  const { instance, accounts } = useMsal();
  const [graphData, setGraphData] = useState(null);

  function RequestProfileData() {
    // Silently acquires an access token which is then attached to a request for MS Graph data
    instance
      .acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
      })
      .then((response) => {
        callMsGraph(response.accessToken).then((response) => setGraphData(response));
      });
  }

  return (
    <>
      <h5 className="card-title">Welcome {accounts[0].name}</h5>
      <br />
      {graphData ? (
        <ProfileData graphData={graphData} />
      ) : (
        <Button variant="secondary" onClick={RequestProfileData}>
          Request Profile Information
        </Button>
      )}
    </>
  );
};

/**
 * If a user is authenticated the ProfileContent component about is rendered. Otherwise, a message indicating a user is not authenticated, is rendered.
 */
const MainContent = () => {
  return (
    <div className="App">
      <AuthenticatedTemplate>
        {/*  */}
        <h5>
          <center>
            Please sign-in to Microsoft Azure...
          </center>
        </h5>
        <ProfileContent />
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <MessageContent />
      </UnauthenticatedTemplate>
    </div>
  );
};

export default function App() {
  return (
    <PageLayout>
      <center>
        <MainContent />
      </center>
    </PageLayout>
  );
}